import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Upload, Select } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const ManagementForm = ({ initialValues, onSuccess, editMode }) => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);

    useEffect(() => {
        if (initialValues) {
            const newInitialValues = {
                ...initialValues,
            };
            
            if (typeof initialValues.image === 'string') {
                newInitialValues.image = [
                    {
                        uid: '-1',
                        name: 'image.jpg',
                        status: 'done',
                        url: `${BASE_URL}${initialValues.image}`,
                    },
                ];
            }

            form.setFieldsValue(newInitialValues);
        } else {
            form.resetFields();
        }
    }, [initialValues, form]);

    const handleFinish = async (values) => {
        const formData = new FormData();
        formData.append('name', values.name);
        formData.append('department', values.department);
        formData.append('role', values.role);
        if (fileList.length > 0) {
            formData.append('image', fileList[0].originFileObj);
        }
        await onSuccess(formData);
        form.resetFields();
    };

    return (
        <Form 
            form={form}
            layout='vertical'
            onFinish={handleFinish}
        >
            <Form.Item
                label="Name"
                name="name"
            >
                <Input placeholder='Masukkan Nama' />
            </Form.Item>

            <Form.Item
                label="Department"
                name="department"
            >
                <Input placeholder='Masukkan department' />
            </Form.Item>

            <Form.Item
                label="Role"
                name="role"
                rules={[{ required: true, message: 'Please select role' }]}
            >
                <Select placeholder="Select Role">
                    <Select.Option value="BOD">BOD</Select.Option>
                    <Select.Option value="BOC">BOC</Select.Option>
                </Select>
            </Form.Item>

            <Form.Item
                label="Image"
                name="image"
            >
                <Upload
                    beforeUpload={() => false}
                    fileList={fileList}
                    onChange={({ fileList }) => setFileList(fileList)}
                    maxCount={1}
                >
                    <Button icon={<UploadOutlined />}>Upload Gambar</Button>
                </Upload>
            </Form.Item>

            <Form.Item style={{ textAlign: 'right' }}>
                <Button
                    htmlType='submit'
                    style={{
                        backgroundColor: '#ec4899',
                        borderColor: '#ec4899',
                        color: '#fff',
                    }}
                >
                   {editMode ? "Update" : "Add"}
                </Button>
            </Form.Item>
        </Form>
    );
};

export default ManagementForm;